export const homeWidgetUrl = (extensionId: string) =>
  `/home/widget/${encodeURIComponent(extensionId)}`;

export const homeWidgetsUrl = () => "/home/widgets";

export const homeUrl = () => "/home";
